import { useTranslation } from 'react-i18next'

const CoachBefore = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="coach-after-title"
      fill="none"
      {...props}
    >
      <title id="coach-after-title">{t('antagonists:coach:components:end')}</title>
      <defs>
        <clipPath id="coach-after-b">
          <path
            d="M1553.61 446.8s12.4 39.43 5.21 59.56c-7.19 20.13-23.43 29.94-23.43 44.32s9.05 48.42 6.17 75.74-38.12 87.43-42.87 104.53c-8.98 32.38-10.71 64.29-10.71 64.29s78.68 15.88 136.19 12.28c57.51-3.59 92.51-10.15 92.51-10.15s-1.33-9.89-3.12-45.19c-1.17-22.99-8.1-53.16-4.51-80.48s10.15-78.38 16.62-101.39c6.48-23-8.28-40.68-7.55-68.71.71-28.03 6.24-54.51 6.24-54.51l-30.18-9.17s-14.06 37.22-53.91 38.3c-46.48 1.25-58.55-40.34-58.55-40.34l-28.13 10.92Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.c{fill:none}.d{fill:#004a7c}.e{fill:#ed7925}.f{fill:#ea6343}.g{fill:#edce5c}.h{fill:#00a39a}.i{fill:#b37b42}.j{fill:#e2007a}.k{fill:#e2a972}.l{fill:#9d3187}.m{clip-path:url(#b)}'
          }
        </style>
      </defs>
      <path
        d="M1754.91 459.93c-9.72-8.68-46.5-16.1-46.5-16.1l8.66 123.9s-5.02 50.62-6.64 66.31c-1.62 15.69 21.25 139.83 21.25 155.52s-.54 25.43-.54 25.43l24.35 5.95s10.28-80.07 12.44-108.75c2.16-28.68-7.58-68.71-5.42-85.49 2.16-16.77 7.47-67.74 5.73-113.89-.55-14.6-4.19-44.72-13.34-52.89h-.01Zm-211.23-23.16s-12.79 12.13-20.2 17.38c-6.42 4.55-12.37 4.85-18 12.52-8.08 11.01-11.86 59.06-30.03 91.98-23.45 42.5-20.04 80.98-7.86 87.44 8.87 4.69 36.34-5.95 45.75-26.51 9.42-20.55 16.06-48.77 20.5-65.07 4.44-16.32 4.76-16.68 13.83-22.34 14.75-9.2 29.49 33.39 29.49 33.39l30.95-11.62 40.54-82.57-104.98-34.6Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1513.16 710.91s-33.92 71.24-19.4 141c10.81 51.91 41.99 152.72 41.51 171.61-.48 18.89 1.06 79.89 10.22 113.19s31.81 98.37 31.81 98.37 13.84 3.45 23.28 1.87c9.42-1.58 16.62-6.04 16.62-6.04s-2.17-54.46.29-87.91c2.46-33.45-14.09-76.81-12.19-97.9s4.56-39.29 2.71-69.04c-1.84-29.77 2.61-241.21 2.61-241.21l-97.46-23.95h.01Z"
        style={{
          fill: '#9d3187',
        }}
      />
      <path
        d="M1697.35 677.67s22.84 107.31 16.2 178.26c-4.95 52.79-22.41 156.28-22.09 175.17.6 35.81 7.03 86.78 2.47 113.62-5.77 34.04-20.64 101.31-20.64 101.31s-13.38 4.98-22.92 4.45c-9.54-.52-18.52-6.24-18.52-6.24s-2.58-52.26-8.77-85.21c-6.17-32.97 5.43-77.91 1.2-98.66s-8.92-38.54-10.41-68.32-29.5-239.41-29.5-239.41l113-74.97h-.01Z"
        style={{
          fill: '#9d3187',
        }}
      />
      <path
        d="M1598.28 362.46s7.91 39.22 2.82 55.2c-5.82 18.24-64.47 37.4-64.47 37.4s6.15 67.55 8.87 66.64c2.74-.91 192.9-15.47 192.9-15.47l-6.86-54.2s-50.99-10.35-61.72-37.7c-10.71-27.35-1.48-54.32-1.48-54.32l-70.08 2.45h.01Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1553.61 446.8s12.4 39.43 5.21 59.56c-7.19 20.13-23.43 29.94-23.43 44.32s9.05 48.42 6.17 75.74-38.12 87.43-42.87 104.53c-8.98 32.38-10.71 64.29-10.71 64.29s78.68 15.88 136.19 12.28c57.51-3.59 92.51-10.15 92.51-10.15s-1.33-9.89-3.12-45.19c-1.17-22.99-8.1-53.16-4.51-80.48s10.15-78.38 16.62-101.39c6.48-23-8.28-40.68-7.55-68.71.71-28.03 6.24-54.51 6.24-54.51l-30.18-9.17s-14.06 37.22-53.91 38.3c-46.48 1.25-58.55-40.34-58.55-40.34l-28.13 10.92Z"
        style={{
          fill: '#e2007a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#coach-after-b)',
        }}
      >
        <path
          d="M1474.77 626.94s68.3-3.93 86.53 57.96c19.03 64.62-21.54 102.07-21.54 102.07s73.24-8.73 75.67-97.68c2.53-92.68-112.56-131.7-112.56-131.7l-28.1 69.36Z"
          style={{
            fill: '#ea6343',
          }}
        />
        <path
          d="M1769.18 536.72s-62.88 22.37-96.65-32.1c-35.25-56.86-7.38-103.88-7.38-103.88s-66.21 28.32-44.48 114.4c22.66 89.69 140.92 95.83 140.92 95.83l7.59-74.25Z"
          style={{
            fill: 'none',
          }}
        />
      </g>
      <path
        d="M1733.71 788.98s-1.64 15.32-5.38 19.58c-3.74 4.28-6.1 9.14-8.68 22.81-2.57 13.67-2.8 44.15-2.8 44.15s5.9 3.7 8.39-2.43c2.5-6.15 3.84-27.06 6.6-26.51s5.18 19.72 5.18 19.72-13.34 10.06-14.04 13.51.78 5 .78 5 12.37-6.12 12.92-5.29c1.4 2.12-11.86 13.4-13.32 17.06-1.46 3.66.99 7.56.99 7.56s7.97-3.96 12.65-7.51c4.66-3.55 10.27-9.06 12.35-12.24s6.98-26.6 8.03-30.88-2.43-35.87-.63-43.05 2.31-26.88 2.31-26.88l-25.34 5.38h-.01Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1625.18 219.43c-15.77.56-29.93 7.66-28.89 24.13 1.04 16.46 15.81 15.37 14.77 19.34-.95 3.62-27.54 9.84-32.98 19.96s-9.34 36.97-7.4 44.75c1.95 7.78 12.46 30.74 12.46 30.74l84.06 2.72s8.95-20.24 12.46-33.85c3.51-13.62 0-32.69-5.84-42.41-5.84-9.73-31.85-19.48-30.96-22.56 1.1-3.82 18.73.07 17.67-24.8-.66-15.76-25.53-18.35-35.33-18.01Z"
        style={{
          fill: '#edce5c',
        }}
      />
      <path
        d="M1629.46 299.98c-20.55-2.57-29.83 12.1-39.43 18.59-9.58 6.49-5.32 19.15-7.66 21.1s-5.06-8.17-10.9-6.23c-5.84 1.95.91 19.74 2.65 26.8 1.75 7.11 2.1 9.35 5.35 9.45 2.75.08 5.61-2.78 5.61-2.78s1.98 16.42 3.51 22.57c2.47 10.04 17.52 26.07 27.24 29.96 9.73 3.89 18.04 6.15 25.82.3s22.99-18.4 25.93-31.04c1.7-7.36.84-17.14 2.65-20.43 1.26-2.28 4.01-1.15 5.83-2.19 2.82-1.59 2.12-8.74 3.29-14.59s1.88-16.66-1.46-17.5c-2.91-.73-4.08 5.66-6.42 4.88-2.34-.78-.78-17.9-6.61-25.3-5.84-7.4-26.07-12.46-35.42-13.62l.03.03Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1611.76 393.6c-.95 3.4 5.91 10.92 16.55 10.24s14.37-6.56 14.77-8.73-.27-5.1-6.23-5.1c-3.96 0-7.01.92-9.43 1.32s-3.85-.93-7.89-.8-6.83-.34-7.77 3.07Z"
        style={{
          fill: '#ed7925',
        }}
      />
      <path
        d="m1610.22 261.19.55 2.2s9.76-1.29 16.44-1.17 16.31 1.21 16.31 1.21l.34-2.28s-10.6-1.64-17.3-1.51c-6.68.12-16.36 1.55-16.36 1.55h.01Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <path
        d="M1615.45 339.05s-7.77-1.54-13.14-1.42c-5.38.11-12.04 4.55-12.04 4.55l1.59 3.66s7.93-3.99 10.71-3.31c3.18.77 12.72 1.51 12.72 1.51s.52-5.32.16-4.98Zm19.09.65s6.79-2.53 11.69-3.11c4.89-.59 11.69 2.91 11.69 2.91l-.82 3.81s-7.86-2.9-10.27-1.87c-2.75 1.17-11.29 3.15-11.29 3.15s-1.36-5.18-.99-4.89Z"
        style={{
          fill: '#b37b42',
        }}
      />
      <path
        d="m1605.03 357.49-6.7 1.92-.84-2.24 7.8-2.64s-.04 2.93-.26 2.97Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        style={{
          fill: '#004a7c',
        }}
        d="m1604.71 355.23-6.82-2.75.66-2.28 6.27 2.25-.11 2.78z"
      />
      <path
        d="M1604.49 351.7c-2.08 1.48-2.54 3.95-1.02 5.93 1.54 1.98 4 2.01 5.95.8 2.31-1.44 2.19-3.86.82-6.06-.96-1.55-3.62-2.19-5.76-.66ZM1646.3 355.85l6.87 1.15.59-2.32-8.04-1.76s.36 2.9.59 2.91h-.01Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        style={{
          fill: '#004a7c',
        }}
        d="m1646.35 353.58 6.48-3.5-.91-2.19-5.98 2.94.41 2.75z"
      />
      <path
        d="M1646.19 350.04c2.24 1.25 2.97 3.63 1.66 5.77-1.31 2.14-3.75 2.45-5.83 1.46-2.45-1.17-2.6-3.6-1.48-5.94.78-1.65 3.34-2.57 5.65-1.29Z"
        style={{
          fill: '#004a7c',
        }}
      />
      <path
        d="M1526.92 452.06c.6-4.44 16.97-52.7 17.89-55.09.92-2.39 21.09-31.61 21.09-31.61s4.37 1.04 4.61 3.62c.23 2.57-2.97 9.27-2.97 9.27l8.04-8.95s4.47 2.17 2.17 6.92-12.55 16.51-13.35 18.29c-.8 1.79-1.09 2.68-1.09 2.68l20.51-17.91s3.26 4.28 1.5 6.96-15.98 15.91-16.91 17.05c-2.76 3.38-2.08 7.34-1.73 7.99s1.9-3.4 5.03-6.49 13.16-11.7 13.16-11.7 4.23 2.16 1.97 6.59c-1.36 2.65-9.16 9.03-10.48 10.74s-8.88 15.88-9.73 18.62c-.85 2.75-1.94 19.39-10.06 30.22-3.24 4.32-10.98 14.96-11.99 14.16-6.2-4.92-19.66-6.48-17.64-21.31h-.01Z"
        style={{
          fill: '#e2a972',
        }}
      />
    </svg>
  )
}

export default CoachBefore
